import React from "react";
import TempGraph from './Charts/CpuTempGraph.js';
import CpuGraph from './Charts/CpuGraph';
import MemGraph from './Charts/MemGraph';
import DiskGraph from './Charts/DiskGraph';
import ResponseGraph from './Charts/ResponseGraph';
import { Card,Button, ButtonGroup, Spinner } from "react-bootstrap";


function LiveData(props) {

    const [data, setData] = React.useState(props.tempStats);

    function handleRadio(e) {
        console.log(e.target.id);
        localStorage.setItem("timeScale", e.target.id)
        props.setTimeScale(e.target.id)
        props.setLoading('visible')
    }

    React.useEffect(() => {
        if(data){
        }
        
    }, [data]);

    
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '40px', marginTop: '40px' }}>
                <h3>Time Margin : </h3>
                <ButtonGroup aria-label="Basic example" style={{marginLeft: '20px', marginRight: '40px'}}>
                    <Button variant={localStorage.getItem("timeScale") === "2 Hours" ? "primary" : "outline-primary"} id="2 Hours" onClick={handleRadio}>2 Hours</Button>
                    <Button variant={localStorage.getItem("timeScale") === "Last Day" ? "primary" : "outline-primary"} id="Last Day" onClick={handleRadio}>Last Day</Button>
                </ButtonGroup>
                <Spinner animation="grow" variant="primary" style={{visibility:props.loading}}></Spinner>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <Card className="card-chart">
                    <Card.Title><strong>Temperature of the CPU </strong> </Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">{localStorage.getItem("timeScale") === "2 Hours" ? `last ${localStorage.getItem("timeScale")}` : localStorage.getItem("timeScale")}</Card.Subtitle>
                    <br></br>
                    <TempGraph data={props.tempStats} threshold={props.threshold.cpuTempTh}></TempGraph>
                </Card>
            </div>
            <div style={{ display: "flex", flexDirection: "row", marginTop: '20px' }}>
                <Card className="card-chart">
                    <Card.Title><strong>CPU Usage</strong></Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">{localStorage.getItem("timeScale") === "2 Hours" ? `last ${localStorage.getItem("timeScale")}` : localStorage.getItem("timeScale")}</Card.Subtitle>
                    <br></br>
                    <CpuGraph data={props.cpuStats} threshold={props.threshold.cpuTh}></CpuGraph>
                </Card>
            </div>
            <div style={{ display: "flex", flexDirection: "row", marginTop: '20px' }}>
                <Card className="card-chart">
                    <Card.Title><strong>Memory Usage</strong></Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">{localStorage.getItem("timeScale") === "2 Hours" ? `last ${localStorage.getItem("timeScale")}` : localStorage.getItem("timeScale")}</Card.Subtitle>
                    <br></br>
                    <MemGraph data={props.memStats} threshold={props.threshold.memTh}></MemGraph>
                </Card>
            </div>
            <div style={{ display: "flex", flexDirection: "row", marginTop: '20px' }}>
                <Card className="card-chart">
                    <Card.Title><strong>Disk Usage</strong></Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">{localStorage.getItem("timeScale") === "2 Hours" ? `last ${localStorage.getItem("timeScale")}` : localStorage.getItem("timeScale")}</Card.Subtitle>
                    <br></br>
                    <DiskGraph data={props.diskStats} threshold={props.threshold.diskTh}></DiskGraph>
                </Card>
            </div>
            <div style={{ display: "flex", flexDirection: "row", marginTop: '20px' }}>
                <Card className="card-chart">
                    <Card.Title><strong>Response Time</strong></Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">{localStorage.getItem("timeScale") === "2 Hours" ? `last ${localStorage.getItem("timeScale")}` : localStorage.getItem("timeScale")}</Card.Subtitle>
                    <br></br>
                    <ResponseGraph data={props.responseStats} threshold={props.threshold.responseTimeTh}></ResponseGraph>
                </Card>
            </div>            
        </div>
    );
}

export default LiveData;